<template>
  <div>
    <v-tabs
      v-model="activeTab"
      fixed-tabs
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
      show-arrows
      center-active
      background-color="orange accent-1"
      color="black"
      class="rounded-lg"
      light>
      <v-tab>تفاصيل</v-tab>
      <v-tab>التسليم</v-tab>
      <v-tab>تتبع الشحنة</v-tab>
      <v-tab>التقييم</v-tab>
      <v-tab v-if="isAdminOrManager">سجل التغييرات</v-tab>
      <!-- Details tab start -->
      <v-tab-item>
        <div class="wrapper p-3">
          <section class="shipment-info">
            <v-row>
              <v-col cols="=12" sm="3">
                <AppLabel label="رقم البوليصة " :value="selected.trackingNumber" />
              </v-col>
              <v-col cols="12" sm="9" class="d-flex justify-items-center">
                <AppState :state="selected.state" :options="enums.ShipmentStates" disableMenu />
              </v-col>
              <v-col cols="12" sm="9" class="d-flex justify-items-center">
                <v-checkbox
                  v-model="selected.isLandPrice"
                  label="تسعير ساحة"
                  color="green darken-3"
                  disabled
                  readonly />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5">
                <AppLabel
                  label="الموظف"
                  color="green lighten-3"
                  v-if="selected.createdBy"
                  :value="selected.createdBy.name" />
              </v-col>
              <v-col cols="4">
                <AppLabel label="التاريخ" :value="selected.createDate | ToDate" />
              </v-col>
              <v-col cols="3">
                <AppLabel label="الساعه" :value="selected.createDate | ToTime" />
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <span>أخر تعديل تم بواسطة : </span>
              <v-col cols="3">
                <AppLabel
                  label="الموظف"
                  color="green lighten-3"
                  v-if="selected.updatedBy"
                  :value="selected.updatedBy.name" />
              </v-col>
              <v-col cols="4">
                <AppLabel label="التاريخ" :value="selected.updateDate | ToDate" />
              </v-col>
              <v-col cols="3">
                <AppLabel label="الساعه" :value="selected.updateDate | ToTime" />
              </v-col>
            </v-row>
          </section>

          <hr />
          <v-row justify="start" align="start" dense class="mb-0">
            <v-col cols="12" sm="4">
              <AppLabel label="التاريخ" :value="selected.date | ToDate" />
            </v-col>

            <v-col cols="12" sm="4">
              <AppLabel label="نوع الخدمة" :value="selected.serviceType.name" />
            </v-col>
            <v-col cols="12" sm="4" v-if="selected.paymentPaidType">
              <AppLabel label="طريقة السداد" :value="selected.paymentPaidType | PaymentPaidTypes" />
            </v-col>
            <v-col cols="12" sm="6">
              <AppLabel label="المسار" :value="selected.trip.line.name" />
            </v-col>

            <v-col cols="12" sm="3">
              <AppLabel label="الرحلة" :value="selected.trip.trackingNumber" />
            </v-col>
            <v-col cols="12" sm="3" v-if="selected.serviceType.id == 2">
              <v-autocomplete
                disabled
                dense
                outlined
                v-model="selected.dueExternalShipperId"
                :items="dueexternalShippers"
                label="المخرج"
                item-text="name"
                item-value="id"
                auto-select-first />
            </v-col>
            <v-col cols="12" sm="4">
              <AppLabel label=" طريقة الدفع" :value="selected.paymentType | PaymentTypes" />
            </v-col>
            <v-col cols="12" sm="4 " v-if="selected.manualNo != 0">
              <AppLabel label="الرقم اليدوى" :value="selected.manualNo" />
            </v-col>
            <v-col cols="12" sm="4" v-if="selected.book != null">
              <AppLabel label="الدفتر" :value="selected.book.manualNo" />
            </v-col>
          </v-row>
          <v-row />

          <v-row class="my-0 ammar" dense>
            <v-col cols="12" sm="5" class="d-flex">
              <span>
                <v-icon class="m-2" v-if="selected.senderInfo && selected.senderInfo.id">fa fa-user</v-icon>
              </span>
              <AppLabel label="المرسل" :value="selected.senderInfo.name" />
            </v-col>

            <v-col
              cols="12"
              sm="3"
              v-if="
                selected.senderInfo
                  && selected.senderInfo.branches
                  && selected.senderInfo.branches.length > 0
              ">
              <AppLabel label="الفرع" :value="selected.senderInfo.branch" />
            </v-col>

            <v-col cols="12" sm="3">
              <AppLabel label="رقم الجوال" :value="selected.senderInfo.phoneNumber" />
            </v-col>
            <v-col cols="12" sm="3">
              <AppLabel label="رقم هوية المرسل" :value="selected.senderInfo.idNum" />
            </v-col>
            <v-col cols="12" sm="5" class="d-flex">
              <span>
                <v-icon class="m-2" v-if="selected.receiverInfo && selected.receiverInfo.id">fa fa-user</v-icon>
              </span>
              <AppLabel label="المستلم" :value="selected.receiverInfo.name" />
            </v-col>
            <v-col
              cols="12"
              sm="3"
              v-if="
                selected.receiverInfo
                  && selected.receiverInfo.branches
                  && selected.receiverInfo.branches.length > 0
              ">
              <AppLabel label="الفرع" :value="selected.receiverInfo.branch" />
            </v-col>
            <v-col cols="12" sm="3">
              <AppLabel label="رقم الجوال" :value="selected.receiverInfo.phoneNumber" />
            </v-col>
            <v-col cols="12" sm="3">
              <AppLabel label="رقم هوية المرسل" :value="selected.receiverInfo.idNum" />
            </v-col>
            <!-- reciver -->

            <v-col cols="12" sm="6">
              <v-row>
                <v-col>
                  <AppLabel v-if="selected.salesman" label="المندوب" :value="selected.salesman.name" />
                  <AppLabel v-if="!selected.salesman" label="المندوب" value="لا يوجد مندوب" />
                </v-col>
              </v-row>
              <v-row v-if="selected.salesman && selected.commessionReceived">
                <v-col class="d-flex justify-content-start align-items-center">
                  <span> تم استلام العمولة </span>
                  <i class="far fa-check-circle mr-2" style="color: green" />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" class="my-0 py-0">
              <v-textarea
                outlined
                hide-details
                readonly
                disabled
                label="الملاحظات"
                v-model="selected.notice"
                rows="2" />
            </v-col>

            <!-- auto completes -->
          </v-row>
          <hr />
          <v-row>
            <v-col cols="12" class="my-0 py-0">
              <v-switch v-model="selected.includeTax" label="متضمن  الضريبه" disabled readonly />
            </v-col>
          </v-row>
          <!-- shipment items start -->

          <v-row class="my-0" dense v-for="(item, index) in selected.items" :key="index">
            <v-col cols="12" sm="2">
              <AppLabel label="الصنف" :value="item.merchandise.name" />
            </v-col>
            <v-col cols="12" sm="2">
              <AppLabel label="الوحده" :value="item.unit.name" />
            </v-col>
            <v-col cols="12" sm="2">
              <AppLabel label="الاحجام" :value="item.size | Sizes" />
            </v-col>
            <v-col cols="12" sm="1">
              <AppLabel label="الكمية" :value="item.quantity" />
            </v-col>
            <v-col cols="12" sm="1">
              <AppLabel label="السعر" :value="item.price" />
            </v-col>
            <v-col cols="12" sm="2">
              <AppLabel label="القيمة المضافة" :value="item.addedValueTax" />
            </v-col>

            <v-col cols="12" sm="2">
              <AppLabel label="المجموع" :value="itemPrice()" />
            </v-col>
          </v-row>

          <!-- shipment items end -->
          <hr />
          <!-- poilsa details -->
          <v-row class="my-0 ammar" dense>
            <v-col cols="12" sm="2">
              <AppLabel label="القيمة التقدرية للتأمين" :value="selected.insurance" />
            </v-col>
            <v-col cols="12" sm="2">
              <AppLabel label="المسترد" :value="selected.duePrice" />
            </v-col>

            <v-col cols="12" sm="3">
              <AppLabel label="التوصيل" :value="selected.deliveryPrice" />
            </v-col>
            <v-col cols="12" sm="2">
              <AppLabel label="التغليف" :value="selected.otherServicesPrice" />
            </v-col>
            <v-col cols="12" sm="3">
              <AppLabel label="القيمة المضافة" :value="selected.addedValueTax" />
            </v-col>
          </v-row>
          <v-row v-if="selected.packagings && selected.packagings.length > 0" class="my-1" dense>
            <v-col cols="12">
              <h4 class="font-weight-bold primary--text"><i class="fa fa-boxes ml-1"></i> تفاصيل التغليف:</h4>
              <v-chip v-for="(p, pIdx) in selected.packagings" :key="pIdx" class="ml-2 mb-1" color="blue-grey lighten-4" small>
                {{ p.packagingMaterialName }} (العدد: {{ p.quantity }}) - الإجمالي: {{ p.total || (p.quantity * p.unitPrice) }} ر.س
              </v-chip>
            </v-col>
          </v-row>
          <hr />
          <v-row class="justify-content-end border-top-2 align-items.center">
            <v-row v-if="selected.paymentPaidType == 5">
              <v-col cols="12" sm="3">
                <AppLabel label="كاش" :value="selected.cash" />
              </v-col>
              <v-col cols="12" sm="3">
                <AppLabel label="شبكة" :value="selected.creditCard" />
              </v-col>
            </v-row>
            <v-row v-if="selected.paymentPaidType == 7">
              <v-col cols="12" sm="3">
                <AppLabel label="كاش" :value="selected.cash" />
              </v-col>
              <v-col cols="12" sm="3">
                <AppLabel label="تحويل بنكي" :value="selected.bankTransfer" />
              </v-col>
            </v-row>
            <v-col cols="12" sm="3">
              <AppLabel label="الصافي" :value="selected.netPrice" />
            </v-col>
            <v-col cols="12" sm="3">
              <AppLabel label="إجمالي السعر" :value="selected.totalPrice" />
            </v-col>
          </v-row>
        </div>
      </v-tab-item>
      <!-- Details tab end -->

      <!-- Recipient tab -->
      <v-tab-item>
        <div class="wrapper p-3">
          <v-row>
            <v-col class="d-flex justify-content-start align-items-center">
              <span>نوع التسليم:</span>
              <span class="h3 m-3">{{ selected.recipientType | RecipientTypes }}</span>
            </v-col>
          </v-row>
          <RecipientInfo :shipment="selected" />
        </div>
      </v-tab-item>
      <!-- Delivery tab -->
      <!-- Tracking tab -->
      <v-tab-item>
        <div class="wrapper p-3">
          <section class="shipment-info">
            <div>
              <div class="follow-order">
                <div class="container">
                  <!--  <div class="order-progress">
                    <span class="shape">
                      <i class="fas fa-chevron-left"></i>
                      تتبع الشحنات
                    </span>
                    <div class="content">
                      <h2>معلومات الشحنة</h2>
                      <div class="steps">
                        <hr class="plain" />
                        <hr class="actly" />
                        <div class="step done step-one">
                          <div class="icon">
                            <i class="fas fa-box"></i>
                          </div>
                          <div class="title">تم الاستلام</div>
                        </div>
                        <div class="step done step-two">
                          <div class="icon">
                            <i class="fas fa-people-carry"></i>
                          </div>
                          <div class="title">مركز المعالجة</div>
                        </div>
                        <div class="step step-three">
                          <div class="icon">
                            <i class="fas fa-flag-checkered"></i>
                          </div>
                          <div class="title">تم التسليم</div>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <div class="order-statue" v-if="selected.activities.length > 0">
                    <h2
                      id="ContentPlaceHolder1_divTitle"
                      class="title"
                      :style="enums.ShipmentTracking[
                        selected.activities[selected.activities.length - 1].state - 1
                      ].color
                      ">
                      حالة الشحنة:
                      {{
                        enums.ShipmentTracking[
                          selected.activities[selected.activities.length - 1].state - 1
                        ].text
                      }}
                      <span v-if="selected.activities[selected.activities.length - 1].state <= 2">
                        {{ selected.trip.line.source.city.name }}
                      </span>
                      <span v-else-if="selected.activities[selected.activities.length - 1].state == 3">
                        {{ selected.trip.line.destination.city.name }}
                      </span>
                      <span v-else-if="selected.activities[selected.activities.length - 1].state == 7">
                        {{ selected.trip.transitCity.name }}
                      </span>
                    </h2>
                    <hr />
                    <div class="row">
                      <div class="column-one col-md-2 col-xs-6">
                        <div class="path">
                          <div id="ContentPlaceHolder1_ToCity" class="to">
                            {{ selected.trip.line.destination.city.name }}
                          </div>
                          <div class="hr">
                            <i class="fas fa-chevron-up" />
                          </div>
                          <div id="ContentPlaceHolder1_FromCity" class="from">
                            {{ selected.trip.line.source.city.name }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-10 col-xs-6">
                        <div class="path-date">
                          <div class="hr" />
                          <ul v-for="(item, i) in selected.activities.slice().reverse()" :key="i">
                            <li :style="enums.ShipmentTracking[item.state - 1].color">
                              <span v-if="item.state <= 2">
                                {{ enums.ShipmentTracking[item.state - 1].text }}
                                {{ selected.trip.line.source.city.name }}
                              </span>
                              <span v-else-if="item.state == 3">
                                {{ enums.ShipmentTracking[item.state - 1].text }}
                                {{ selected.trip.line.destination.city.name }}
                              </span>
                              <span v-else-if="item.state == 7">
                                {{ enums.ShipmentTracking[item.state - 1].text }}
                                {{ selected.trip.transitCity.name }}
                              </span>
                              <span v-else>
                                {{ enums.ShipmentTracking[item.state - 1].text }}
                              </span>
                              <br />
                              <span>
                                {{ item.date | ToDate }}
                                {{ item.date | ToTime }}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </v-tab-item>
      <!-- Tracking tab -->
      <!-- Rating tab -->
      <v-tab-item>
        <div class="wrapper p-3">
          <v-row v-if="loadingRating" justify="center" class="my-5">
            <v-progress-circular indeterminate color="primary" />
          </v-row>
          <div v-else-if="ratingData">
            <v-card class="pa-4 rounded-lg elevation-1" outlined>
              <v-row align="center" class="mb-2">
                <v-col cols="12" sm="6">
                  <div class="d-flex align-center">
                    <span class="font-weight-bold ml-3 text-subtitle-1">تقييم العميل:</span>
                    <v-rating :value="ratingData.rate" color="amber" dense half-increments readonly size="24" />
                    <span class="mr-2 font-weight-bold primary--text">({{ ratingData.rate }} / 5)</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" class="text-sm-left" v-if="ratingData.createDate">
                  <span class="grey--text text--darken-1">تاريخ التقييم: {{ ratingData.createDate | ToDate }}</span>
                </v-col>
              </v-row>

              <v-divider class="my-3" />

              <v-row class="mb-2" v-if="formattedRatingPoints.length > 0">
                <v-col cols="12">
                  <div class="font-weight-bold mb-2" style="text-align: start;">نقاط التقييم المختارة:</div>
                  <div class="d-flex flex-wrap">
                    <v-chip
                      v-for="(point, idx) in formattedRatingPoints"
                      :key="idx"
                      :color="ratingData.rate > 3 ? 'green lighten-4' : 'red lighten-4'"
                      :text-color="ratingData.rate > 3 ? 'green darken-4' : 'red darken-4'"
                      class="ma-1 font-weight-medium"
                      label>
                      <v-icon left small :color="ratingData.rate > 3 ? 'green darken-3' : 'red darken-3'">
                        {{ ratingData.rate > 3 ? 'mdi-star' : 'mdi-heart-broken' }}
                      </v-icon>
                      {{ point }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <v-col cols="12">
                  <div class="font-weight-bold mb-2" style="text-align: start;">التعليق:</div>
                  <v-card outlined class="pa-3 grey lighten-4 rounded-lg">
                    <p
                      style="text-align: start;"
                      class="mb-0 text-body-1"
                      v-if="ratingData.comment && ratingData.comment.trim()">
                      {{ ratingData.comment }}
                    </p>
                    <p style="text-align: start;" class="mb-0 text-caption grey--text font-italic" v-else>
                      لا يوجد تعليق
                    </p>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <v-alert v-else type="info" text class="my-4 text-center">
            لا يوجد تقييم لهذه الشحنة.
          </v-alert>
        </div>
      </v-tab-item>
      <!-- Rating tab -->

      <!-- Logs tab -->
      <v-tab-item v-if="isAdminOrManager">
        <div class="wrapper p-3">
          <v-data-table
            :headers="logHeaders"
            :items="auditLogs"
            :loading="loadingLogs"
            class="elevation-1"
            no-data-text="لا توجد تعديلات مسجلة"
          >
            <template v-slot:[`item.date`]="{ item }">
              <span>{{ item.date | ToDate }} {{ item.date | ToTime }}</span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-chip :color="getActionColor(item.action)" dark small>
                {{ getActionText(item.action) }}
              </v-chip>
            </template>
            <template v-slot:[`item.user`]="{ item }">
              <span>{{ item.userFullName || item.username || 'نظام تلقائي' }}</span>
            </template>
            <template v-slot:[`item.changes`]="{ item }">
              <div v-if="item.changes">
                <div v-for="(change, idx) in parseChanges(item.changes)" :key="idx" class="my-1">
                  <strong>{{ getPropertyLabel(change.Property) }}:</strong>
                  <s class="red--text text--darken-2 mx-1">{{ formatValue(change.Property, change.OldValue) }}</s>
                  <span class="mx-1 grey--text font-weight-bold">←</span>
                  <span class="green--text text--darken-2 font-weight-bold mx-1">{{ formatValue(change.Property, change.NewValue) }}</span>
                </div>
              </div>
              <span v-else>-</span>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>
    </v-tabs>
    <v-card-actions>
      <v-spacer />
      <v-btn color="red darken-1" text @click="cancelview()">إلغاء</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import Enums from "@/plugins/enums.js";
import ExternalShippersService from "../services/ExternalShippersService";
import RatingService from "../services/RatingService";
import ShipmentService from "../services/ShipmentService";

export default {
  props: ["selected"],
  data() {
    return {
      activeTab: 0,
      enums: Enums,
      dueexternalShippers: [],
      ratingData: null,
      loadingRating: false,
      auditLogs: [],
      loadingLogs: false,
      logHeaders: [
        { text: "التاريخ والوقت", value: "date", width: "20%" },
        { text: "العملية", value: "action", width: "15%" },
        { text: "الموظف", value: "user", width: "20%" },
        { text: "التغييرات التفصيلية", value: "changes", sortable: false }
      ],
      nicePointsMap: {
        1: "توصيل سريع",
        2: "تغليف آمن",
        3: "خدمة ممتازة",
        4: "جودة المنتجات",
        5: "دفع سهل",
      },
      negativePointsMap: {
        1: "تأخير في التوصيل",
        2: "دعم بطيء",
        3: "معلومات محدودة",
        4: "شحن مرتفع",
      },
    };
  },
  computed: {
    isAdminOrManager() {
      const { user } = this.$store.getters;
      if (!user || !user.roles) return false;
      return user.roles.some(r => r.name === 'SystemAdmin' || r.name === 'Manager');
    },
    formattedRatingPoints() {
      if (!this.ratingData || !this.ratingData.ratingIds) return [];
      const ids = this.ratingData.ratingIds
        .toString()
        .split(",")
        .map((i) => parseInt(i.trim()))
        .filter((i) => !isNaN(i));

      const isPositive = this.ratingData.rate > 3;
      return ids
        .map((id) => {
          if (isPositive) {
            return this.nicePointsMap[id] || this.negativePointsMap[id] || "";
          }
          return this.negativePointsMap[id] || this.nicePointsMap[id] || "";

        })
        .filter(Boolean);
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.trackingNumber) {
          this.fetchRating(newVal.trackingNumber);
        } else {
          this.ratingData = null;
        }
        if (this.activeTab === 4 && newVal && newVal.id) {
          this.fetchLogs();
        } else {
          this.auditLogs = [];
        }
      },
    },
    activeTab(newTab) {
      if (newTab === 4 && this.selected && this.selected.id) {
        this.fetchLogs();
      }
    },
  },
  mounted() {
    this.activeTab = 0;
    ExternalShippersService.typeHead("", true).then((resp) => {
      this.dueexternalShippers = resp.data;
    });
  },
  methods: {
    fetchRating(trackingNumber) {
      this.loadingRating = true;
      RatingService.getByTrackingNumber(trackingNumber)
        .then((resp) => {
          this.ratingData = resp.data || null;
        })
        .catch(() => {
          this.ratingData = null;
        })
        .finally(() => {
          this.loadingRating = false;
        });
    },
    fetchLogs() {
      this.loadingLogs = true;
      ShipmentService.getLogs(this.selected.id)
        .then((resp) => {
          this.auditLogs = resp.data || [];
        })
        .catch(() => {
          this.auditLogs = [];
        })
        .finally(() => {
          this.loadingLogs = false;
        });
    },
    getActionColor(action) {
      if (action === "Created") return "success";
      if (action === "Updated") return "primary";
      if (action === "Deleted") return "error";
      return "grey";
    },
    getActionText(action) {
      if (action === "Created") return "إنشاء";
      if (action === "Updated") return "تعديل";
      if (action === "Deleted") return "حذف";
      return action;
    },
    parseChanges(changesStr) {
      try {
        const parsed = JSON.parse(changesStr) || [];
        return parsed.filter(change => {
          let oldVal = change.OldValue;
          let newVal = change.NewValue;
          if (oldVal === newVal) return false;
          if ((oldVal === null || oldVal === "null" || oldVal === "" || oldVal === "None") &&
              (newVal === null || newVal === "null" || newVal === "" || newVal === "None")) {
            return false;
          }
          // ignore default empty dates
          if (typeof oldVal === "string" && oldVal.startsWith("1/1/0001") &&
              typeof newVal === "string" && newVal.startsWith("1/1/0001")) {
            return false;
          }
          return true;
        });
      } catch (e) {
        return [];
      }
    },
    getPropertyLabel(prop) {
      const labels = {
        State: "الحالة",
        state: "الحالة",
        TripId: "الرحلة",
        tripId: "الرحلة",
        DriverId: "السائق",
        driverId: "السائق",
        CarId: "السيارة",
        carId: "السيارة",
        SenderId: "المرسل",
        senderId: "المرسل",
        ReceiverId: "المستلم",
        receiverId: "المستلم",
        TotalPrice: "إجمالي السعر",
        totalPrice: "إجمالي السعر",
        NetPrice: "الصافي",
        netPrice: "الصافي",
        ManualNo: "الرقم اليدوي",
        manualNo: "الرقم اليدوي",
        Notice: "الملاحظات",
        notice: "الملاحظات",
        DeliveryPrice: "سعر التوصيل",
        deliveryPrice: "سعر التوصيل",
        OtherServicesPrice: "سعر التغليف",
        otherServicesPrice: "سعر التغليف",
        DuePrice: "المسترد",
        duePrice: "المسترد",
        PaymentType: "طريقة الدفع",
        paymentType: "طريقة الدفع",
        PaymentPaidType: "طريقة السداد",
        paymentPaidType: "طريقة السداد",
        IsInventoried: "تم الجرد",
        isInventoried: "تم الجرد",
        RentAmount: "قيمة الإيجار",
        rentAmount: "قيمة الإيجار",
        TotalExpenses: "إجمالي المصاريف",
        totalExpenses: "إجمالي المصاريف",
        Date: "التاريخ",
        date: "التاريخ",
        SenderBranchId: "فرع المرسل",
        senderBranchId: "فرع المرسل",
        ReceiverBranchId: "فرع المستلم",
        receiverBranchId: "فرع المستلم",
        TrackingNumber: "رقم التتبع",
        trackingNumber: "رقم التتبع",
        TaxNum: "الرقم الضريبي",
        taxNum: "الرقم الضريبي",
        IncludeTax: "شامل الضريبة",
        includeTax: "شامل الضريبة",
        AddedValueTax: "ضريبة القيمة المضافة",
        addedValueTax: "ضريبة القيمة المضافة",
        AddedValueTaxDiscount: "خصم ضريبة القيمة المضافة",
        addedValueTaxDiscount: "خصم ضريبة القيمة المضافة",
        Insurance: "التأمين",
        insurance: "التأمين",
        Discount: "الخصم",
        discount: "الخصم",
        Cash: "نقداً",
        cash: "نقداً",
        CreditCard: "شبكة",
        creditCard: "شبكة",
        OtherServicesPriceReceived: "تم استلام سعر التغليف",
        otherServicesPriceReceived: "تم استلام سعر التغليف",
        DuePriceReceived: "تم استلام المسترد",
        duePriceReceived: "تم استلام المسترد",
        SMSCitySent: "تم إرسال رسالة المدينة",
        smsCitySent: "تم إرسال رسالة المدينة",
        ReceiverCall: "اتصال المستلم",
        receiverCall: "اتصال المستلم",
        IsLandPrice: "سعر بري",
        isLandPrice: "سعر بري",
        AppDeliveryDate: "تاريخ التسليم في التطبيق",
        appDeliveryDate: "تاريخ التسليم في التطبيق",
        InventoriedCount: "عدد المواد المجرودة",
        inventoriedCount: "عدد المواد المجرودة",
        IsSenderClient: "المرسل عميل",
        isSenderClient: "المرسل عميل",
        IsReceiverClient: "المستلم عميل",
        isReceiverClient: "المستلم عميل",
        CommessionReceived: "تم استلام العمولات",
        commessionReceived: "تم استلام العمولات",
        DeliveryTripCost: "تكلفة رحلة التوصيل",
        deliveryTripCost: "تكلفة رحلة التوصيل",
        DeliveryTripId: "رحلة التوصيل",
        deliveryTripId: "رحلة التوصيل",
        BookId: "دفتر الشحنات",
        bookId: "دفتر الشحنات",
        ServiceTypeId: "نوع الخدمة",
        serviceTypeId: "نوع الخدمة",
        SalesmanId: "المندوب",
        salesmanId: "المندوب",
        ReceiveReceiptId: "إيصال الاستلام",
        receiveReceiptId: "إيصال الاستلام",
        ExternalShipperDeliveryInfoId: "معلومات تسليم الشاحن الخارجي",
        externalShipperDeliveryInfoId: "معلومات تسليم الشاحن الخارجي",
        RecipientDeliveryInfoId: "معلومات تسليم المستلم",
        recipientDeliveryInfoId: "معلومات تسليم المستلم",
        DistributorDeliveryInfoId: "معلومات تسليم الموزع",
        distributorDeliveryInfoId: "معلومات تسليم الموزع",
        CommessionId: "العمولة",
        commessionId: "العمولة",
        AdderCityId: "مدينة الإضافة",
        adderCityId: "مدينة الإضافة",
        CityId: "المدينة",
        cityId: "المدينة",
        ReceiverCityId: "مدينة المستلم",
        receiverCityId: "مدينة المستلم",
        IsDeleted: "تم الحذف",
        isDeleted: "تم الحذف",
        CreatedById: "منشئ السجل",
        createdById: "منشئ السجل",
        CreateDate: "تاريخ الإنشاء",
        createDate: "تاريخ الإنشاء",
        RecipientType: "نوع المستلم",
        recipientType: "نوع المستلم",
        ReceiveFromDistributorDate: "تاريخ الاستلام من الموزع",
        receiveFromDistributorDate: "تاريخ الاستلام من الموزع",
        OldTotalPrice: "السعر الإجمالي السابق",
        oldTotalPrice: "السعر الإجمالي السابق",
        AddToDistributorDate: "تاريخ التسليم للموزع",
        addToDistributorDate: "تاريخ التسليم للموزع",
        DueExternalShipperId: "معرف الشاحن الخارجي المستحق",
        dueExternalShipperId: "معرف الشاحن الخارجي المستحق",
        TotalPriceDiscount: "خصم السعر الإجمالي",
        totalPriceDiscount: "خصم السعر الإجمالي"
      };
      if (labels[prop]) return labels[prop];
      return prop
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    },
    formatValue(prop, val) {
      if (val === null || val === undefined || val === "null" || val === "None") return "بلا قيمة";
      if (val === "true" || val === "True" || val === true) return "نعم";
      if (val === "false" || val === "False" || val === false) return "لا";
      
      // If it's a date and starts with 1/1/0001 or 0001-01-01
      if (typeof val === "string" && (val.startsWith("1/1/0001") || val.startsWith("0001-01-01"))) {
        return "بلا قيمة";
      }

      const propLower = prop.toLowerCase();

      if (propLower === "state") {
        const stateInt = parseInt(val, 10);
        if (!isNaN(stateInt)) {
          const stateObj = this.enums.ShipmentStates.find(s => s.value === stateInt);
          return stateObj ? stateObj.text : val;
        }
        if (val === "Pending") return "قيد الانتظار";
        if (val === "InDelivery") return "تحت التوصيل";
        if (val === "Delivered") return "تم التسليم";
        return val;
      }

      if (propLower === "paymenttype") {
        const payInt = parseInt(val, 10);
        if (payInt === 1 || val === "Cash") return "نقدي";
        if (payInt === 2 || val === "Deferred") return "أجل عميل";
        if (payInt === 3 || val === "Transfer") return "تحويل";
        if (payInt === 4 || val === "Network") return "شبكة";
        if (val === "CashOnDelivery") return "الدفع عند الاستلام";
        return val;
      }

      if (propLower === "paymentpaidtype") {
        const payPaidInt = parseInt(val, 10);
        if (payPaidInt === 1 || val === "Sender") return "خالص أجرة المرسل";
        if (payPaidInt === 2 || val === "Receiver") return "خالص أجرة المستلم";
        if (payPaidInt === 3 || val === "OnAccount") return "على الحساب";
        return val;
      }

      if (propLower === "recipienttype") {
        if (val === "Distributor") return "موزع";
        if (val === "Client") return "عميل";
        return val;
      }

      return val;
    },
    cancelview() {
      this.$emit("hide");
      this.activeTab = 0;
    },
    itemPrice() {
      const addedValueTaxPercentage = this.$store.getters.tax;
      const price = parseFloat(this.selected.items[0].price | 0);
      const quantity = parseInt(this.selected.items[0].quantity | 0);
      var total = quantity * price;
      if (this.selected.includeTax) {
        var total = total - (total / (1 + addedValueTaxPercentage)) * addedValueTaxPercentage;
        return this.round(total, 2);
      }
      const addedValueTax = addedValueTaxPercentage * total;
      return this.round(total + addedValueTax, 2);

    },
  },
};
</script>

<style>
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: black;
}

.shipment-info {
  border-radius: 0.5rem;
  background: #f8f8f8;
  padding: 1rem;
}

input[type="checkbox"][id^="myCheckbox1"] {
  display: none;
}

.labels {
  border: 5px solid #fff;
  padding: 10px;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

label:before {
  background-color: white;
  color: white;
  content: " ";
  display: block;
  border-radius: 50%;
  border: 1px solid grey;
  position: absolute;
  top: -5px;
  left: -5px;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 28px;
  transition-duration: 0.4s;
  transform: scale(0);
}

label img {
  height: 40px;
  width: 100px;
  transition-duration: 0.2s;
  transform-origin: 50% 50%;
}

:checked+label {
  border-color: rgb(17, 219, 108);
}

:checked+label:before {
  content: "✓";
  background-color: grey;
  transform: scale(1);
}

:checked+label img {
  transform: scale(0.9);
  /* box-shadow: 0 0 5px #333; */
  z-index: -1;
}

.follow-order {
  text-align: start;
}

.follow-order .order-progress .shape {
  background-color: #fff;
  padding: 10px 30px;
  width: fit-content;
  height: fit-content;
  border-top-left-radius: 20px;
  font-size: 12px;
}

.follow-order .order-progress .content {
  background-color: #fff;
  padding: 50px 20px;
}

.follow-order .order-progress .content .progress-line .plain {
  color: #eeeeee;
  background-color: #eeeeee;
}

.follow-order .order-progress .content h2 {
  font-size: 15px;
}

.follow-order .order-progress .content .steps {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  background: #eeeeee;
  position: relative;
  padding: 50px;
  font-weight: 200;
}

/* .follow-order .order-progress .content .steps .progress-line {
  position: absolute;
  width: 100%;
} */

.follow-order .order-progress .content .steps hr {
  position: absolute;
  top: 50%;
  width: 100%;
  margin: 0;
  z-index: 1;
}

.follow-order .order-progress .content .steps .plain {
  background: #4b4b4b;
}

.follow-order .order-progress .content .steps .actly {
  background: #117d5d;
  height: 5px;
  width: 60%;
  left: 0;
  opacity: 1;
  overflow: initial;
}

.follow-order .order-progress .content .steps .actly::after {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  -moz-border-radius: 7.5px;
  -webkit-border-radius: 7.5px;
  border-radius: 50%;
  background-color: #347e5d;
  transform: translate(12px, -8px);
  z-index: 5;
}

.follow-order .order-progress .content .steps .step {
  z-index: 2;
  text-align: center;
  margin-top: 20px;
}

.follow-order .order-progress .content .steps .step .icon {
  width: 50px;
  height: 50px;
  border: 1px solid #616161;
  border-radius: 50%;
  line-height: 50px;
  text-align: center;
  background-color: #eeeeee;
  font-size: 23px;
}

.follow-order .order-progress .content .steps .step.done .icon {
  background-color: #117d5d;
  color: #fff;
  border: 0;
}

.follow-order .order-progress .content .steps .step .title {
  font-size: 14px;
  transform: translateY(10px);
}

.follow-order .order-statue {
  background-color: #fff;
  padding: 20px;
}

.follow-order .order-statue h2 {
  font-size: 20px;
  font-weight: bold;
}

.follow-order .order-statue .path .to {
  width: 100px;
  height: 100px;
  line-height: 90px;
  text-align: center;
  border-radius: 50%;
  background-color: #eee;
  border: 3px solid #117d5d;
  padding: 2px;
}

.follow-order .order-statue .path .hr {
  width: 2px;
  height: 50px;
  background-color: #8e8e8e;
  margin-right: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.follow-order .order-statue .path .from {
  width: 100px;
  height: 100px;
  line-height: 90px;
  text-align: center;
  border-radius: 50%;
  background-color: #eee;
  border: 3px solid #000000;
  padding: 2px;
}

.follow-order .order-statue .path-date {
  position: relative;
  margin-right: 50px;
}

.follow-order .order-statue .path-date ul {
  color: rgb(107, 107, 107);
  padding: 1.1rem;
  position: relative;
  z-index: 2;
}

.follow-order .order-statue .path-date ul li {
  margin: 10px 0;
}

.follow-order .order-statue .path-date ul li.now {
  color: #117d5d;
}

.follow-order .order-statue .path-date .hr {
  width: 2px;
  height: 100%;
  background-color: #8e8e8e;
  position: absolute;
  right: 0;
  z-index: 1;
}

.follow-order .order-info {
  margin: 50px 0;
}

.follow-order .order-info .shape {
  background-color: #fff;
  padding: 10px 30px;
  width: fit-content;
  height: fit-content;
  border-top-left-radius: 20px;
  font-size: 12px;
}

.follow-order .order-info .the-info {
  background-color: #fff;
  padding: 50px;
}

.follow-order .order-info .the-info ul {
  list-style: none;
  color: #616161;
}

.follow-order .order-info .the-info ul li {
  margin: 10px auto;
}

.follow-order .order-info .the-info .with-border {
  border-left: 2px solid #444444;
}

@media (max-width: 998px) {
  .follow-order .order-info .the-info .with-border {
    border-left: none;
  }
}

@media (max-width: 768px) {
  .follow-order .order-statue .row .column-one {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .follow-order .order-statue .path-date {
    margin-top: 50px;
  }
}

@media (max-width: 560px) {
  .follow-order .order-progress .content .steps .step .title {
    font-size: 10px;
  }

  .follow-order .order-progress .content .steps .step {
    margin-left: 10px;
    margin-right: 10px;
  }

  .follow-order .order-info .the-info {
    padding: 50px 0;
  }
}
</style>
